import React from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Typography,
  Box,
} from '@mui/material';
import {
  People,
  Payment,
  TrendingUp,
  Settings,
  Category,
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';

const DRAWER_WIDTH = 240;

const menuItems = [
  {
    text: 'אנליטיקס',
    icon: <TrendingUp />,
    path: '/analytics',
  },
  {
    text: 'ניהול משתמשים',
    icon: <People />,
    path: '/users',
  },
  {
    text: 'דוחות תשלומים',
    icon: <Payment />,
    path: '/billing',
  },
  {
    text: 'ניהול התמחויות',
    icon: <Category />,
    path: '/specializations',
  },
  {
    text: 'ניהול סוגי שיעורים',
    icon: <Settings />,
    path: '/class-types',
  },
];

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: DRAWER_WIDTH,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: DRAWER_WIDTH,
          boxSizing: 'border-box',
          top: '64px', // Height of AppBar
          height: 'calc(100% - 64px)',
        },
      }}
    >
      <Box sx={{ p: 2 }}>
        <Typography variant="h6" color="primary" align="center">
          ניהול המערכת
        </Typography>
      </Box>
      
      <Divider />
      
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              selected={location.pathname === item.path}
              onClick={() => handleNavigation(item.path)}
              sx={{
                '&.Mui-selected': {
                  backgroundColor: 'primary.light',
                  color: 'black', // 👈 change text color
                  '& .MuiListItemIcon-root': {
                    color: 'white', // 👈 change icon color
                  },
                },
              }}
            >
              <ListItemIcon>
                {item.icon}
              </ListItemIcon>
              <ListItemText 
                primary={item.text}
                sx={{ textAlign: 'right' }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      
      <Divider sx={{ mt: 'auto' }} />     
      
    </Drawer>
  );
};

export default Sidebar;
